import { Component } from '@angular/core';

@Component({
    selector: 'studio',
    template: require('./studio.component.html'),
})

export class StudioComponent {    

    constructor() {
    
    }
    
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/main/studio/studio.component.ts
 **/